import QRReportPage from './qr-report';
import ProductReportPage from './product-report';
import MainPage from './main-page';
import CampaignPage from './campaign';
import ConsumerPage from './consumer';
import DealershipPage from './dealership';
import { CreditReportingPage } from './credit-reporting';
import { CreditMovementPage } from './credit-movement';

export {
    QRReportPage,
    ProductReportPage,
    MainPage,
    CampaignPage,
    ConsumerPage,
    DealershipPage,
    CreditReportingPage,
    CreditMovementPage
}